function updatePagePosition() {
    const quickExitLinkDiv = document.querySelector(".quick-exit-ribbon");
    const pageDiv = document.querySelector(".page");
    const webChat = document.querySelector(".wc-webchat");
    const mediaQuery = window.matchMedia("(max-width: 499px)");

    if (quickExitLinkDiv) {
        pageDiv.style.position = "relative";
        pageDiv.style.bottom = quickExitLinkDiv.clientHeight + "px";
        pageDiv.style.paddingTop = quickExitLinkDiv.clientHeight + "px";

        if (webChat && mediaQuery.matches) {
            quickExitLinkDiv.style.bottom = webChat.clientHeight + "px";
        }
    }
}

window.onload = function() {
    updatePagePosition();
};

window.onresize = function() {
    updatePagePosition();
};
